/**
 * ArrowBackIcon — sanitized from `assets/newSvg/arrow-back.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function ArrowBackIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M7.93932,13.0607 C7.35354,12.4749 7.35354,11.5251 7.93932,10.9393 L13.5962,5.28249 C14.182,4.6967 15.1317,4.6967 15.7175,5.28249 C16.3033,5.86827 16.3033,6.81802 15.7175,7.40381 L11.1213,12 L15.7175,16.5962 C16.3033,17.182 16.3033,18.1317 15.7175,18.7175 C15.1317,19.3033 14.182,19.3033 13.5962,18.7175 L7.93932,13.0607 Z"
        fill={color}
      />
    </Svg>
  );
}

export default ArrowBackIcon;
